module.exports = __webpack_public_path__ + "media/customizations/trailmark/back-90426483b4d5a6c97231b604a06c5e90.jpg";